import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../theme/mediaQueriesTemplates";
import animate from "../../utils/animations";

export const Wrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 70px;
  z-index: 3;

  ${mediaMinWidth.smallDesktop} {
    display: none;
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
  }
`;

export const MenuTrigger = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5em;
  ${animate("bounceIn", 0.4, 0.1)};

  .fa-times {
    ${animate("bounceIn", 0.4, 0.1)};
  }

  &:focus {
    outline: none;
  }
`;

export const MenuOptions = styled.ul`
  position: absolute;
  right: 0;
  top: 37px;
  display: flex;
  flex-direction: column;
  font-size: 0.6em;
  width: 205px;
  align-items: flex-end;
  background-color: #fff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  padding: 5px;
  margin: 0;
  ${animate("fadeInUp", 0.1, 0)};
`;

interface IOptionProps {
  clickable?: boolean;
}

export const Option = styled.li`
  display: flex;
  padding: 4px 7px;
  border-radius: 4px;
  margin: 2.5px 0;
  width: 100%;
  color: #333;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  cursor: ${(props: IOptionProps) => (props.clickable ? "pointer" : "unset")};

  &:hover {
    color: ${(props: IOptionProps) => props.clickable && "#fff"};
    background-color: ${(props: IOptionProps) => props.clickable && "#f2008c"};
  }
`;

export const OptionText = styled.div`
  strong {
    margin-left: 7px;
    font-family: sans-serif;
  }
`;

export const OptionDescription = styled.label`
  font-weight: 400;
  text-align: left;
  font-size: 0.8em;
  margin-bottom: 10px;
`;
